// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1HrbB","label":"Section_label__2zqG9","contentWrap":"Section_contentWrap__Rxf6F","footer":"Section_footer__dHhZQ","footerInner":"Section_footerInner__13vWA"};